// extracted by mini-css-extract-plugin
export default {"root":"login-form_root__Z9uYH","form":"login-form_form__yz+4E","header":"login-form_header__-E7xu","button":"login-form_button__OHFIB"};